import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { PairingCodeModal } from '../components/PairingCodeModal';

/**
 * PairPage - Standalone page for generating kiosk pairing codes.
 *
 * Deep link allows admins to quickly generate codes from any device.
 * Shows appropriate message based on auth state:
 * - Not logged in: prompt to sign in
 * - Not admin: permission denied
 * - Admin: display pairing modal
 */
export function PairPage() {
  const { isAuthenticated, user } = useAuthStore();
  const isAdmin = user?.role === 'admin';

  // Not authenticated: prompt to sign in
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4">
        <div className="card max-w-sm w-full text-center">
          <h1 className="text-xl font-semibold text-text-primary mb-4">Sign In Required</h1>
          <p className="text-text-secondary mb-6">
            Sign in to generate a pairing code for your kiosk device.
          </p>
          <Link
            to="/login"
            className="inline-block px-6 py-3 bg-soft-cyan text-white rounded-lg font-medium"
          >
            Sign In
          </Link>
        </div>
      </div>
    );
  }

  // Authenticated but not admin: permission denied
  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4">
        <div className="card max-w-sm w-full text-center">
          <h1 className="text-xl font-semibold text-text-primary mb-4">Admin Required</h1>
          <p className="text-text-secondary mb-6">
            Only family admins can generate kiosk pairing codes.
          </p>
          <Link to="/" className="text-blue hover:underline">
            Return to Home
          </Link>
        </div>
      </div>
    );
  }

  // Admin: show pairing modal with home navigation on close
  return <PairingCodeModal onClose={() => window.location.href = '/'} />;
}
